const React = require('react')
const PropTypes = require('prop-types')
const Page = require('app/page')
const Headline = require('./components/headline')
const Cards = require('./components/cards')
const Footer = require('./components/footer')
const VendastaChatWidget = require('component/VendastaChatWidget')
const withStyles = require('withStyles').default
const styles = require('./home.less')
const radio = require('lib/radio')
const log = require('log').create('home') // eslint-disable-line

class Home extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            google: null,
            facebook: null,
        }
    }

    componentDidMount() {
        this.showBanner()
        this.sendMetrics()
        this.initializeListeners()
        this.initializeOnboardingController()
    }

    showBanner() {
        const { missing_user_name } = this.props
        if (! missing_user_name) return

        require.ensure([], () => {
            const Dialog = require('module/dialog/dialog')
             
            const text = `There is no one by the name ‘${missing_user_name}’. Please check the name and try again.`
            Dialog.banner({
                text,
            })
        }, 'homepage')
    }

    sendMetrics() {
        radio.metrics_signup.trigger('homepage:visit')
    }

    initializeListeners() {
        radio.auth.on('facebook:failed', () => {
            this.setState({
                facebook: false,
            })
        })
        radio.auth.on('google:failed', () => {
            this.setState({
                google: false,
            })
        })
        radio.auth.on('facebook:loaded', () => {
            this.setState({
                facebook: true,
            })
        })
        radio.auth.on('google:initialized', () => {
            this.setState({
                google: true,
            })
        })
    }

    initializeOnboardingController() {
        require.ensure([], () => {
            const $ = require('lib/jquery')
            const OnboardingController = require('./onboarding_controller')
            // need to initiate with all google signup node
            this.onboarding_controller = new OnboardingController({
                google_button: $('.social-button.google'),
            })
        }, 'home_onboarding')
    }

    render() {
        const { google, facebook } = this.state
        const { variant } = this.props

        const nav_props = {
            link_logo: false,
            signup_button_props: {
                href: '/signup/email',
                desktop_text: 'Get your free page',
                mobile_text: 'Get your page',
                onClick: (e) => {
                    e.preventDefault()
                    this.onboarding_controller.onClickSignupEmail()
                },
            },
        }

        return (
            <Page nav_props={nav_props} className={styles.scope}>
                <Headline enable_facebook={facebook} enable_google={google} variant={variant} />
                <Cards variant={variant} />
                <Footer enable_facebook={facebook} enable_google={google} variant={variant} />
                <VendastaChatWidget />
            </Page>
        )
    }

}

Home.propTypes = {
    missing_user_name: PropTypes.string,
    variant: PropTypes.string,
}

Home.defaultProps = {
    missing_user_name: '',
    variant: '',
}



/* munges data necessary for building the page
@param props (Object) - props returned to the callback of react-router's match
@param pageData (Object) - data that is sent to ServerPage for rendering
@param dataResults (Object) - data returned from from server/lib/data_sources.js
    the keys of this data are defined by the keys you specify in the return of
    getDataRequirements
*/
function getPageData(props, pageData, dataResults) {
    // title
    pageData.title = 'about.me | your personal homepage'
    pageData.metas.push({
        name: 'og:title',
        content: pageData.title,
    })
    pageData.metas.push({
        name: 'twitter:title',
        content: pageData.title,
    })

    // facebook-specific
    pageData.metas.push({
        name: 'og:site_name',
        content: 'about.me',
    })
    pageData.metas.push({
        name: 'og:locale',
        content: 'en_US',
    })
    pageData.metas.push({
        name: 'og:url',
        content: 'https://about.me',
    })
    pageData.metas.push({
        name: 'og:type',
        content: 'aboutme_prod:page',
    })
    pageData.metas.push({
        name: 'fb:app_id',
        content: '249413078192',
    })

    // twitter-specific
    pageData.metas.push({
        name: 'twitter:site',
        content: '@aboutdotme',
    })
    pageData.metas.push({
        name: 'twitter:card',
        content: 'summary',
    })
    pageData.metas.push({
        name: 'twitter:url',
        content: 'https://about.me',
    })

    // meta descriptions
    const meta_description = 'Create your free, one-page website in just a few minutes.'
    pageData.metas.push({
        name: 'description',
        content: meta_description,
    })
    pageData.metas.push({
        name: 'og:description',
        content: meta_description,
    })
    pageData.metas.push({
        name: 'twitter:description',
        content: meta_description,
    })

    // images
    // using 'facebook' image for both because it's square
    // twitter card is using 'summary' type (not 'photo'), which has square image
    pageData.metas.push({
        name: 'og:image',
        content: require('images/logos/social.png'),
    })
    pageData.metas.push({
        name: 'twitter:image',
        content: require('images/logos/social.png'),
    })
    pageData.metas.push({
        name: 'twitter:image:alt',
        content: 'about.me logo',
    })

    return pageData
}

const StyledHome = withStyles(styles)(Home)
StyledHome.getPageData = getPageData

module.exports = StyledHome
